export default __webpack_public_path__ + "static/media/img-web-app.a0ac4a80.svg";